import { render, staticRenderFns } from "./ActivateTemplate.vue?vue&type=template&id=5ba67ac2"
import script from "./ActivateTemplate.vue?vue&type=script&lang=js"
export * from "./ActivateTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports